module.exports = "/virtual-football-league/img/amblems/right/logos/Leverkusen.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Leverkusen.png
// module id = 2209
// module chunks = 4